import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Button from './Button';

const DokumenteSlider = ({ formulare }) => {

    const [slidesToShow, setSlidesToShow] = useState(3);

    const [current, setCurrent] = useState(slidesToShow);

    const sliderRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            if (width <= 600) {
                setSlidesToShow(1);
                setCurrent(1);
            } else if (width <= 1024) {
                setSlidesToShow(2);
                setCurrent(2);
            } else {
                setSlidesToShow(3);
                setCurrent(3);
            }

            // setCurrent((prev)=>{return prev + 1});
        };

        // run on mount
        handleResize();

        // listen to resize
        window.addEventListener("resize", handleResize);

        // cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const slides = [1, 2, 3, 4, 5, 6];

    // const settings = {
    //     dots: false,
    //     arrows: true,
    //     infinite: false,
    //     speed: 500,
    //     slidesToShow: slidesToShow,   // default (desktop)
    //     slidesToScroll: 1,
    //     cssEase: "linear",
    //     beforeChange: (oldIndex, newIndex) => {
    //         setCurrent(newIndex + slidesToShow);
    //     },
    //     // responsive: [
    //     //     {
    //     //         breakpoint: 1024, // tablet
    //     //         settings: {
    //     //             slidesToShow: 2
    //     //         }
    //     //     },
    //     //     {
    //     //         breakpoint: 768, // mobile
    //     //         settings: {
    //     //             slidesToShow: 1
    //     //         }
    //     //     }
    //     // ]
    // };

    const [currentSlide, setCurrentSlide] = useState(0);

    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow,
        slidesToScroll: 1,
        cssEase: "linear",
        beforeChange: (_, next) => {
            setCurrentSlide(next);
        }
    };

    // const total = formulare.length;
    // const progress = (current / total) * 100;

    const maxSlides = Math.max(formulare.length - slidesToShow, 1);

    const progress = ((currentSlide + 1) / (maxSlides + 1)) * 100;

    const handleProgressClick = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        const clickX = e.clientX - rect.left;

        // Total slider positions
        const totalParts = maxSlides + 1;

        // Width of each segment
        const partWidth = rect.width / totalParts;

        // Determine which segment was clicked
        const partIndex = Math.floor(clickX / partWidth);

        sliderRef.current?.slickGoTo(partIndex);
        setCurrentSlide(partIndex);
    };

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".dokumente_slider .item_inner h4"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

            // 👉 P elements
            const paragraphs = document.querySelectorAll(
                ".dokumente_slider .item_inner p"
            );

            let maxP = 0;
            paragraphs.forEach((el) => {
                el.style.height = "auto";
                maxP = Math.max(maxP, el.offsetHeight);
            });
            paragraphs.forEach((el) => {
                el.style.height = maxP + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 300);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    const truncateBlocks = (blocks, maxLength = 120) => {
        if (!blocks) return "";

        let text = "";

        for (let block of blocks) {
            if (block.children) {
                for (let child of block.children) {
                    text += child.text;

                    if (text.length >= maxLength) {
                        return text.slice(0, maxLength) + "...";
                    }
                }
            }
        }

        return text;
    };

    return (
        <div className='slider_wrapper slider-arrow-bg slick-slide-margin dokumente_slider pt-4'>
            <Slider ref={sliderRef} {...settings}>
                {/* {slides.map((item, index) => ( */}
                {/* <div key={index} className='slider_slide_item'> */}

                {formulare?.map((item, index) => (
                    <div className='slider_slide_item'>
                        {item?.Komponente === "Page" ? (
                            <Link to={`/${item?.slug}`} className='item_inner'>
                                <img src={`https://backend.bgzurlinden.ch${item?.icon?.url}`} className='icon-size' alt='#' />

                                {item?.Komponente === "Page" ? (
                                    <h4 className="text-darkgrey fw-550">{item?.Bannerbereich[0]?.Titel}</h4>
                                ) : (
                                    <h4 className="text-darkgrey fw-550">{item?.Titel}</h4>
                                )}

                                {item?.Komponente === "Page" ? (
                                    Array.isArray(item.Bannerbereich[0]?.Beschreibung) ? (
                                        <p>{truncateBlocks(item.Bannerbereich[0]?.Beschreibung, 90)}</p>
                                    ) : (
                                        <p>
                                            {item?.Bannerbereich[0]?.Beschreibung?.length > 100
                                                ? item.Bannerbereich[0].Beschreibung.slice(0, 100) + "..."
                                                : item?.Bannerbereich[0]?.Beschreibung}
                                        </p>
                                    )
                                ) : (
                                    <p>
                                        {item?.Text?.length > 200
                                            ? item.Text.slice(0, 200) + "..."
                                            : item?.Text}
                                    </p>
                                )}

                                <div className='btn-container'>
                                    <div className='simple-arrow-btn'>
                                        zur Anmeldung
                                        <span className='ani_arrows'>
                                            <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                                <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                            </svg></span>
                                            <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                                <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                            </svg></span>
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        ) : item?.Komponente === "Button" ? (
                            <Link to={`${item?.Button[0]?.button_link}`} className='item_inner'>
                                <img src={`https://backend.bgzurlinden.ch${item?.icon?.url}`} className='icon-size' alt='#' />

                                {item?.Komponente === "Page" ? (
                                    <h4 className="text-darkgrey fw-550">{item?.Bannerbereich[0]?.Titel}</h4>
                                ) : (
                                    <h4 className="text-darkgrey fw-550">{item?.Titel}</h4>
                                )}

                                {item?.Komponente === "Page" ? (
                                    Array.isArray(item.Bannerbereich[0]?.Beschreibung) ? (
                                        <p>{truncateBlocks(item.Bannerbereich[0]?.Beschreibung, 90)}</p>
                                    ) : (
                                        <p>
                                            {item?.Bannerbereich[0]?.Beschreibung?.length > 100
                                                ? item.Bannerbereich[0].Beschreibung.slice(0, 100) + "..."
                                                : item?.Bannerbereich[0]?.Beschreibung}
                                        </p>
                                    )
                                ) : (
                                    <p>
                                        {item?.Text?.length > 100
                                            ? item.Text.slice(0, 100) + "..."
                                            : item?.Text}
                                    </p>
                                )}

                                <div className='btn-container'>
                                    <div className='simple-arrow-btn'>
                                        {item?.Button[0]?.button_text}
                                        <span className='ani_arrows'>
                                            <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                                <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                            </svg></span>
                                            <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                                <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                            </svg></span>
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        ) : (
                            <a href={`https://backend.bgzurlinden.ch${item?.PDF[0]?.PDF?.url}`} download target="_blank" rel="noopener noreferrer" className='item_inner'>
                                <img src={`https://backend.bgzurlinden.ch${item?.icon?.url}`} className='icon-size' alt='#' />

                                {item?.Komponente === "Page" ? (
                                    <h4 className="text-darkgrey fw-550">{item?.Bannerbereich[0]?.Titel}</h4>
                                ) : (
                                    <h4 className="text-darkgrey fw-550">{item?.Titel}</h4>
                                )}

                                {item?.Komponente === "Page" ? (
                                    Array.isArray(item.Bannerbereich[0]?.Beschreibung) ? (
                                        <p>{truncateBlocks(item.Bannerbereich[0]?.Beschreibung, 90)}</p>
                                    ) : (
                                        <p>
                                            {item?.Bannerbereich[0]?.Beschreibung?.length > 100
                                                ? item.Bannerbereich[0].Beschreibung.slice(0, 100) + "..."
                                                : item?.Bannerbereich[0]?.Beschreibung}
                                        </p>
                                    )
                                ) : (
                                    <p>
                                        {item?.Text?.length > 100
                                            ? item.Text.slice(0, 100) + "..."
                                            : item?.Text}
                                    </p>
                                )}
                                <div className='btn-container'>
                                    <div className='simple-arrow-btn'>
                                        {item?.PDF[0]?.button_text}
                                        <span className='ani_arrows'>
                                            <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                                <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                            </svg></span>
                                            <span className='arrow_arrow'><svg width="40" height="17" viewBox="0 0 40 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M31.4852 16.7591C31.1398 17.0803 30.5797 17.0803 30.2342 16.7591C29.8888 16.4378 29.8888 15.917 30.2342 15.5958L37.8646 8.50002L30.2342 1.40423C29.8888 1.083 29.8888 0.562162 30.2342 0.240926C30.5797 -0.0803021 31.1398 -0.0803078 31.4852 0.240926L39.7409 7.91836C40.0864 8.2396 40.0864 8.76044 39.7409 9.08167L31.4852 16.7591Z" fill="inherit" />
                                                <path d="M0.884545 9.32259C0.396023 9.32259 7.03377e-07 8.9543 7.43093e-07 8.50001C7.82809e-07 8.04571 0.396024 7.67743 0.884545 7.67742L39.1155 7.67743C39.604 7.67743 40 8.04571 40 8.50001C40 8.95431 39.604 9.32259 39.1155 9.32259L0.884545 9.32259Z" fill="inherit" />
                                            </svg></span>
                                        </span>
                                    </div>
                                </div>
                            </a>
                        )}
                    </div>
                ))}

            </Slider>
            {/* Top Section */}
            <div className="slider-count-progress">
                <div
                    className="progress"
                    onClick={handleProgressClick}
                    style={{ cursor: "pointer" }}
                >
                    <div
                        className="progress-bar"
                        style={{
                            width: `${progress}%`,
                            transition: "width 0.3s ease"
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default DokumenteSlider